import React, { useState, useEffect } from 'react'
import Breadcrumb from '../breadcrumb/breadcrumb.component'
import { Formik } from 'formik'
import Yup from '../../../../helpers/custom-yup'
import Cep from './cep.component'
import Address from './address.component'
import Cellphone from './cellphone.component'
import Birthday from './birthday.component'
import Mother from './mother.component'
import Topo from '../topo/topo.component'
import Conclusion from './conclusion.component'
import ExpirationDate from './expiration-date.component'
import Password from './password.component'
import ConfirmPassword from './confirm-password.component'
import NewCard from './new-card.component'
import { MuvicardService } from '../../../../services/muvicard.service'

const Main = props => {
	const [step, setStep] = useState(0)
	const [choosen, setChoosen] = useState(null)
	const [paymentDay, setPaymentDay] = useState(null)
	const [status, setStatus] = useState('')
	const [passwordCard, setPasswordCard] = useState('')
	const [cardInfo, setCardInfo] = useState({})
	const [userData, setUserData] = useState({})

	const { toastError, toastSuccess, hideLoading, showLoading, user } = props

	useEffect(() => {
		setStep(1)
		getUserPersonalData()
	}, [])

	async function getUserPersonalData() {
		try {
			showLoading()
			let response = await MuvicardService.getPersonaldata()
			response.success ? setUserData(response.data) : setUserData(null)
		} catch (error) {
			setUserData(null)
		}
	}

	function nextStep() {
		if (step < 10) {
			setStep(step + 1)
		}
	}

	function prevStep() {
		if (step > 0) {
			setStep(step - 1)
		}
	}

	function updateUserData(newUserData) {
		setUserData(newUserData)
	}

	const schema = Yup.object().shape({
		zipCode: Yup.string()
			.postalCode()
			.required('Informe o CEP')
			.nullable(),

		cellPhone: Yup.string()
			.cellphone()
			.required('Informe número do seu celular')
			.nullable(),

		address: Yup.object().shape({
			city: Yup.string()
				.required('Favor informar o nome do teu município')
				.nullable(),
			street: Yup.string()
				.required('Favor informar o nome da tua rua')
				.nullable(),
			neighborhood: Yup.string()
				.required('Favor informar o nome do teu bairro')
				.nullable(),
			number: Yup.string()
				.residenceNumber()
				.required('Favor informar o número')
				.nullable()
		}),
		birthDate: Yup.string()
			.birthday()
			.required('Informe sua data de nascimento')
			.min('10', 'Favor digitar a data completa')
			.nullable(),

		motherName: Yup.string()
			.required('Informe o nome da sua mãe')
			.nullable()
			.name(),
		terms: Yup.string()
			.required('Favor aceite os termos de uso para solicitar o seu cartão')
			.nullable()
	})

	const initialValues = {
		zipCode: '',
		cellPhone: '',
		birthDate: '',
		motherName: '',
		terms: false,
		newsLetter: true,
		address: {
			street: '',
			neighborhood: '',
			number: '',
			complement: ''
		}
	}

	function send(values) {
		const { motherName, newsLetter } = values
		const obj = { motherName, newsLetter }

		MuvicardService.sendPersonalData(obj)
			.then(data => {
				if (data.success) {
					MuvicardService.proposalStepRegister(
						'Nome da mãe',
						'Atualização'
					)
					setStep(6)
					setStatus('wait')
					MuvicardService.proposalRequest().then(response => {
						if (response.success) {
							if (response.data.approved) {
								setTimeout(() => {
									setStatus('success')
								}, 2000)

								setCardInfo({
									cardProposalId: response.data.id
								})
							} else {
								setStep(6)
								setStatus('negative')
							}
						} else {
							setStep(6)
							setStatus('fail')
						}
					})
				} else {
					setStep(6)
					setStatus('fail')
				}
			})
			.catch(e => {
				setStep(6)
				setStatus('fail')
			})
	}

	return (
		<section>
			<Topo step={step} />
			<Breadcrumb step={step} />

			<Formik
				validationSchema={schema}
				initialValues={initialValues}
				onSubmit={(values, action) => {
					send(values)
					action.resetForm()
				}}>
				{props => (
					<form onSubmit={props.handleSubmit} autoComplete="off">
						{step === 1 && (
							<Cep
								{...props}
								nextStep={nextStep}
								showLoading={showLoading}
								hideLoading={hideLoading}
								userData={userData}
								updateUserData={updateUserData}
							/>
						)}
						{step === 2 && (
							<Address
								{...props}
								nextStep={nextStep}
								prevStep={prevStep}
								showLoading={showLoading}
								hideLoading={hideLoading}
								userData={userData}
							/>
						)}
						{step === 3 && (
							<Cellphone
								{...props}
								nextStep={nextStep}
								prevStep={prevStep}
								showLoading={showLoading}
								hideLoading={hideLoading}
								userData={userData}
								updateUserData={updateUserData}
							/>
						)}
						{step === 4 && (
							<Birthday
								nextStep={nextStep}
								prevStep={prevStep}
								showLoading={showLoading}
								hideLoading={hideLoading}
								{...props}
								userData={userData}
								updateUserData={updateUserData}
							/>
						)}
						{step === 5 && (
							<Mother
								{...props}
								showLoading={showLoading}
								hideLoading={hideLoading}
								prevStep={prevStep}
								userData={userData}
								updateUserData={updateUserData}
							/>
						)}

						{step === 6 && (
							<Conclusion
								{...props}
								status={status}
								setStatus={setStatus}
								setStep={setStep}
								setCardInfo={setCardInfo}
								cardInfo={cardInfo}
							/>
						)}
						{step === 7 && (
							<ExpirationDate
								{...props}
								showLoading={showLoading}
								hideLoading={hideLoading}
								step={step}
								setStep={setStep}
								choosen={choosen}
								setChoosen={setChoosen}
								toastSuccess={toastSuccess}
								toastError={toastError}
								paymentDay={paymentDay}
								setPaymentDay={setPaymentDay}
								nextStep={nextStep}
								setCardInfo={setCardInfo}
								cardInfo={cardInfo}
							/>
						)}

						{step === 8 && (
							<Password
								{...props}
								paymentDay={paymentDay}
								passwordCard={passwordCard}
								setPasswordCard={setPasswordCard}
								setStep={setStep}
								prevStep={prevStep}
								setCardInfo={setCardInfo}
								cardInfo={cardInfo}
								paymentDay={paymentDay}
							/>
						)}

						{step === 9 && (
							<ConfirmPassword
								{...props}
								paymentDay={paymentDay}
								passwordCard={passwordCard}
								setPasswordCard={setPasswordCard}
								setStep={setStep}
								prevStep={prevStep}
								setCardInfo={setCardInfo}
								cardInfo={cardInfo}
								paymentDay={paymentDay}
								showLoading={showLoading}
								setStatus={setStatus}
							/>
						)}

						{step === 10 && (
							<NewCard
								{...props}
								setStep={setStep}
								user={user}
								paymentDay={paymentDay}
								passwordCard={passwordCard}
								setCardInfo={setCardInfo}
								cardInfo={cardInfo}
								hideLoading={hideLoading}
							/>
						)}
					</form>
				)}
			</Formik>
		</section>
	)
}

export default Main
